import React, { FC } from "react";
import { Popup } from "antd-mobile";
import styles from "./index.module.scss";

interface IOpenInBrowserProps {
  visible?: boolean;
  onClose?: () => void;
}

const OpenInBrowser: FC<IOpenInBrowserProps> = ({ visible = false }) => {
  return (
    <Popup visible={visible} position="top" bodyClassName={styles.content}>
      <div
        className={styles.tips}
      >
        <div className={styles.tip_item}>
          1、Click The Top-Right Button
          <span className={styles.menu_icon}>...</span>
        </div>
        <div className={styles.tip_item}>
          2、Select
          <img
            src="https://static.hhocool.com/images/browser_icon.png"
            className={styles.browser_icon}
            alt=""
          />
          Open In Browser
        </div>

        <div>
          <div className="top-bar-guidance"></div>
        </div>
      </div>
    </Popup>
  );
};

export default OpenInBrowser;
